import { plural } from '@epicuro-next/platform/i18n';

export function getDeleteSuccessMessageByAmount(amount: number) {
  return plural(
    amount,
    {
      0: $localize`:@@BulkDeleteProductListsSuccessMessage|No Product List Deletion Message@@noProductListDeletionMessage:No product lists were deleted.`,
      1: $localize`:@@BulkDeleteProductListsSuccessMessage|Single Product List Deletion Message@@singleProductListDeletionMessage:1 product list was deleted.`,
    },
    $localize`:@@BulkDeleteProductListsSuccessMessage|Multiple Product Lists Deletion Message@@multipleProductListsDeletionMessage:${amount} product lists were deleted.`,
  );
}
